import { createApp } from 'vue'
import OrganizationAssessmentWidget from '../components/organization_assessment/OrganizationAssessmentWidget.vue'

document.querySelectorAll<HTMLElement>('#organization-assessment-app').forEach((el) => {
  createApp(OrganizationAssessmentWidget, {
    inflowRoute: el.dataset.inflowRoute || '',
  }).mount(el)
})
